import React, { useState, useEffect } from 'react';
//import Cookies from 'js-cookie';

import {
    APP_STORE_LINK,
    GOOGLE_PLAY_LINK
} from '../constants/constants';

import appStore from '../assets/app-store.png';
import googlePlay from '../assets/google-play.png';

const AppDownloadPopup = () => {
    const [isPopupVisible, setIsPopupVisible] = useState(false);

    const isMobile = () => {
        if (typeof window !== 'undefined') {
            const ua = navigator.userAgent;
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
        }
        return false;
    };

    useEffect(() => {
        // Show popup when component mounts
        return;
    }, []);


    const handleClosePopup = () => {
        setIsPopupVisible(false);
    };

    return (
        <>
            {isPopupVisible && (
                <div style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    backgroundColor: 'white',
                    padding: '20px',
                    border: '1px solid #ccc',
                    borderRadius: '5px',
                    boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
                    zIndex: 1000,
                    width: '85%'
                }}>
                    <button onClick={handleClosePopup} style={{ float: 'right', border: 'none', background: 'none', cursor: 'pointer' }}>X</button>
                    <p style={{ textAlign: 'center' }}
                        className={`font-18 font-poppins`}>&nbsp;&nbsp;&nbsp;Download Our App!</p>
                    <div style={{ textAlign: 'center' }}>
                        <p className={`font-13 font-poppins`}>Enhance your experience with our mobile app.</p>
                        <a href={APP_STORE_LINK} aria-label="Download on the App Store" style={{ margin: '0 5px' }}>
                            <img src={appStore} alt="App Store" style={{ verticalAlign: 'middle', width: 'auto', height: '40px' }} />
                        </a>
                        <a href={GOOGLE_PLAY_LINK} aria-label="Get it on Google Play" style={{ margin: '0 5px' }}>
                            <img src={googlePlay} alt="Google Play" style={{ verticalAlign: 'middle', width: 'auto', height: '40px' }} />
                        </a>
                    </div>
                </div>
            )}
        </>
    );
};

export default AppDownloadPopup;